import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceProviderProfileData } from 'src/app/models/service-provider-profile-data.model';
import { ServicePlan } from 'src/app/models/service_plan.model';
import { ServiceProvider } from 'src/app/models/service_provider.model';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatDivider } from "@angular/material/divider";
import { MatCardContent, MatCard, MatCardTitle, MatCardHeader, MatCardActions, MatCardSubtitle } from "@angular/material/card";
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
  imports: [MatProgressBar, MatDivider, MatCardContent, MatCard, MatCardTitle, MatCardHeader, MatCardActions, MatCardSubtitle, MatButtonModule]
})
export class ProfilePageComponent implements OnInit {
  loading = false;
  servicePlans: ServicePlan[] = [];
  profileImage!: any;
  serviceProvider!: ServiceProvider;
  serviceProviderProfileData!: ServiceProviderProfileData;


  constructor(
    private userService: TokenStorageService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private serviceProviderService: ServiceProviderService,
  ) { }

  ngOnInit() {
    this.getServiceProviderProfileData();
    this.getProfileImage();
  }

  getServiceProviderProfileData(): void {
    const queryParam = new Map();
    const serviceProviderId = this.route.snapshot.params['id'];
    this.serviceProviderService.get([serviceProviderId, 'profile'], queryParam).subscribe(result => {
      this.serviceProviderProfileData = result;
    })

  }

  getProfileImage(): void {
    const serviceProviderId = this.route.snapshot.params['id'];
    const queryParams = new Map();
    this.serviceProviderService.get([serviceProviderId, 'ProfileImage'], queryParams).subscribe((result: any) => {
      this.profileImage = result.data.imageData;
    });
  }

  navigateToShoppingPage(id: string): void {
    this.router.navigate([`product-view/${id}`]);
  }


}
